import React, {useEffect, useState} from 'react';
import {GET_COLLECTION_AGGREGATE_DATA} from '../../api';
import $ from 'jquery';
import 'parsleyjs';
import {capitalize} from "../../utils/capitalize";
import moment from "moment/moment";
import {getUserReport} from "../../api/app";
import {useSelector} from "react-redux";
import formatNumber from "../../utils/formatNumber";

let searchableFields = [
    { field: 'name', isNumeric: false },
    { field: 'mobile_number', isNumeric: true }
]

const Applicant = () => {

    document.title = "Applicant";

    const token = localStorage.getItem('jwtToken');
    const auth = useSelector((state) => state.auth.user);
    const [id, setId] = useState(new Date().getTime());
    const [useAI, setUseAI] = useState(false);
    const [requiresDocs, setRequiresDocs] = useState(false);
    const [applicationType, setApplicationType] = useState("external");
    const [editorModal, setEditorModal] = useState({ open: false, id: "", title: "" });
    const [editorValues, setEditorValues] = useState({ description: "", qualifications: "", experience: "" });

    const handleOpenEditor = (id, title) => {
        setEditorModal({ open: true, id, title });
    };

    const handleCloseEditor = () => {
        setEditorModal({ open: false, id: "", title: "" });
    };

    const [stateReady, setStateReady] = useState(false);

    // useEffect(() => {
    //     getUserReport().then((response) => {
    //         if(!response.error) {
    //             $('#total-users').text(formatNumber(response.payload.total_users, "digit"));
    //             $('#total-assignment').text(formatNumber(response.payload.total_assignments, "digit"));
    //             $('#total-submission').text(formatNumber(response.payload.total_submissions, "digit"));
    //         }
    //     });
    // }, []);

    useEffect(() => {
        var KTDatatableRemoteDataDemo = (function () {
            var isInitialized = false;
            var instance = null;

            var resolveDataTableClass = function () {
                if (typeof window === 'undefined') return null;
                if (window.KTDataTable) return window.KTDataTable;
                if (window.KTUI && window.KTUI.KTDataTable) return window.KTUI.KTDataTable;
                return null;
            };

            var init = function () {
                var KTDataTable = resolveDataTableClass();
                if (!KTDataTable) {
                    console.warn('KTDataTable is not loaded yet. Retrying...');
                    setTimeout(init, 100);
                    return null;
                }

                if (isInitialized && instance) return instance;

                var datatableEl = document.getElementById('kt_datatable_remote_source');
                if (!datatableEl) return null;

                if (datatableEl.hasAttribute('data-kt-datatable-initialized')) {
                    if (typeof KTDataTable.getInstance === 'function') {
                        var oldInstance = KTDataTable.getInstance(datatableEl);
                        if (oldInstance && typeof oldInstance.dispose === 'function') {
                            oldInstance.dispose();
                        }
                    }
                    datatableEl.removeAttribute('data-kt-datatable-initialized');
                    if (datatableEl.instance) delete datatableEl.instance;
                }

                var datatable = new KTDataTable(datatableEl, {
                    apiEndpoint: GET_COLLECTION_AGGREGATE_DATA,
                    requestMethod: 'POST',
                    requestHeaders: {
                        Authorization: token,
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    mapRequest: function (queryParams) {
                        return JSON.stringify({
                            query: queryParams.search || queryParams.query || '',
                            collection: 'applicant',
                            searchableFields,
                            filter: {},
                            pageSize: queryParams.pageSize || 10,
                            pageIndex: queryParams.page || 1,
                            format: 'json',
                            populate: [
                                {
                                    path: 'user',
                                    model: 'user',
                                    populate: [
                                        {
                                            path: 'location.provincial',
                                            model: 'administrative'
                                        },
                                        {
                                            path: 'location.district',
                                            model: 'district'
                                        },
                                        {
                                            path: 'location.constituency',
                                            model: 'constituency'
                                        }
                                    ]
                                },
                                {
                                    path: 'opportunity',
                                    model: 'opportunity',
                                    populate: [
                                        {
                                            path: 'company',
                                            model: 'company'
                                        }
                                    ]
                                },
                            ],
                            sort: { _id: -1 }
                        });
                    },
                    mapResponse: function (res) {
                        return {
                            data: res.data || [],
                            totalCount: res.total || 0,
                            page: res.page || 1,
                            pageSize: res.pageSize || 10,
                            totalPages: Math.ceil((res.total || 0) / (res.pageSize || 10)),
                        };
                    },
                    columns: {
                        user: {
                            title: 'Name',
                            render: function (value) {
                                return value ? `${capitalize(value.name) ?? ''}`.trim() : '—';
                            },
                        },
                        "user.gender": {
                            title: 'Gender',
                            render: function (value, row) {
                                return capitalize(row?.user?.gender) ?? '—';
                            }
                        },
                        status: {
                            title: 'Status',
                            render: function (value) {
                                return `<span class="kt-badge">${capitalize(value ?? 'pending')}</span>`;
                            },
                        },
                        createdAt: {
                            title: 'Date',
                            render: function (value) {
                                return value ? moment(value).format('DD MMM YYYY') : '—';
                            },
                        },
                        _id: {
                            title: 'Action',
                            render: function (value) {
                                return `<div class="kt-menu" data-kt-menu="true">
                                          <div class="kt-menu-item" data-kt-menu-item-offset="0, 10px" data-kt-menu-item-placement="bottom-start" data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click">
                                           <button class="kt-menu-toggle kt-btn kt-btn-sm kt-btn-icon kt-btn-outline">
                                            <i class="ki-filled ki-dots-vertical text-lg">
                                            </i>
                                           </button>
                                           <div class="kt-menu-dropdown kt-menu-default w-full max-w-[200px]" data-kt-menu-dismiss="true">
                                            <div class="kt-menu-item">
                                             <a class="kt-menu-link" href="#">
                                              <span class="kt-menu-icon">
                                               <i class="ki-filled ki-check">
                                               </i>
                                              </span>
                                              <span class="kt-menu-title">
                                               Approve
                                              </span>
                                             </a>
                                            </div>
                                            <div class="kt-menu-item">
                                             <a class="kt-menu-link" data-kt-modal-toggle="#share_profile_modal" href="#">
                                              <span class="kt-menu-icon">
                                               <i class="ki-filled ki-bandage">
                                               </i>
                                              </span>
                                              <span class="kt-menu-title">
                                               Reject
                                              </span>
                                             </a>
                                            </div>
                                            <div class="kt-menu-item">
                                             <a class="kt-menu-link" data-kt-modal-toggle="#report_user_modal" href="#">
                                              <span class="kt-menu-icon">
                                               <i class="ki-filled ki-trash">
                                               </i>
                                              </span>
                                              <span class="kt-menu-title">
                                               Delete
                                              </span>
                                             </a>
                                            </div>
                                          </div>
                                         </div>`
                            }
                        }
                    },
                    pageSize: 10,
                    stateSave: true,
                });

                isInitialized = true;
                instance = datatable;
                return instance;
            };

            return {
                init: function () {
                    return init();
                }
            };
        })();

        function safeInitialize() {
            var element = document.getElementById('kt_datatable_remote_source');
            if (!element) return;

            var instance = KTDatatableRemoteDataDemo.init();
            if (instance) window.datatableInstance = instance;
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', safeInitialize, { once: true });
        } else {
            setTimeout(safeInitialize, 1);
        }
    }, []);

    const validateStep = (step) => {
        const errors = [];

        if (step === 1) {
            // Step 1: Opportunity type (radio) — at least one must be selected
            const typeSelected = document.querySelector('input[name="opportunity_type"]:checked');
            if (!typeSelected) {
                errors.push('Please select an opportunity type to continue.');
            }
        }

        if (step === 2) {
            // Position name
            const position = document.getElementById('position');
            if (!position?.value.trim()) {
                errors.push('Please enter a name for this opportunity.');
            }

            // External link required only if application type is external
            const appType = document.querySelector('input[name="application_type"]:checked')?.value;
            if (appType === 'external') {
                const link = document.getElementById('link');
                if (!link?.value.trim()) {
                    errors.push('Please enter an application link for external applications.');
                }
            }

            // Description is required
            const description = editorValues.description;
            if (!description?.trim()) {
                errors.push('Please add a description for this opportunity.');
            }
        }

        if (step === 3) {
            // Step 3: At least one applicant info field must be checked
            const infoChecked = document.querySelector(
                '#req_name:checked, #req_province:checked, #req_cv:checked, #req_contact:checked, #req_email:checked, #req_id:checked, #req_dob:checked, #req_gender:checked'
            );
            if (!infoChecked) {
                errors.push('Please select at least one information field required from applicants.');
            }
        }

        if (step === 4) {
            // Appearance date and closing date required
            const dateAppear = document.getElementById('date_appear');
            const dateClosing = document.getElementById('date_closing');
            if (!dateAppear?.value.trim()) {
                errors.push('Please select an appearance date.');
            }
            if (!dateClosing?.value.trim()) {
                errors.push('Please select a closing date.');
            }

            // Privacy policy must be checked
            const privacy = document.getElementById('privacy_policy');
            if (!privacy?.checked) {
                errors.push('Please accept the data privacy policy.');
            }
        }

        return errors;
    };

    const showStepErrors = (errors) => {
        // Remove any existing error banner
        const existing = document.getElementById('stepper-validation-error');
        if (existing) existing.remove();

        const activeContent = document.querySelector(
            '#stepper_1:not(.hidden), #stepper_2:not(.hidden), #stepper_3:not(.hidden), #stepper_4:not(.hidden)'
        );
        if (!activeContent) return;

        const banner = document.createElement('div');
        banner.id = 'stepper-validation-error';
        banner.className = 'flex flex-col gap-1 p-4 mb-4 rounded-lg bg-destructive/10 border border-destructive text-destructive text-sm';
        banner.innerHTML = errors.map(e => `<span>• ${e}</span>`).join('');

        activeContent.prepend(banner);

        // Auto-remove after 5s
        setTimeout(() => banner.remove(), 5000);
    };

    const handleShowModal = () => {
        const element = $("#create-modal")[0];
        if(!element) return;
        // initStepperValidation();
        // $("#opportunity-form").parsley();
        let modal = window.KTModal.getInstance(element);
        if(!modal) modal = new window.KTModal(element);
        modal.show();
    }

    const resetForm = (id, form) => {
        $(':input', `#${form}`).not(':button, :submit, :reset, :hidden').val('').prop('checked', false).prop('selected', false);

        const element = $(`#${id}`)[0];
        if (!element) return;
        let modal = window.KTModal.getInstance(element);
        if (!modal) modal = new window.KTModal(element);
        modal.hide();
    };

    const initStepperValidation = () => {
        const stepperEl = document.querySelector('[data-kt-stepper="true"]');
        if (!stepperEl) return;

        const KTStepper = window.KTStepper;
        if (!KTStepper) {
            setTimeout(initStepperValidation, 100);
            return;
        }

        const stepper = KTStepper.getInstance(stepperEl) || new KTStepper(stepperEl);

        stepper.on('change', (detail) => {
            const currentStep = stepper.getStep(stepper.getElement().querySelector('[data-kt-stepper-item].active'));
            // Only validate when moving forward (next), not backward
            if (detail.step <= currentStep) return;

            const errors = validateStep(currentStep);
            if (errors.length > 0) {
                detail.cancel = true;
                showStepErrors(errors);
            }
        });
    };

    return (
        <div>
            <div className="kt-container-fixed">
                <div className="flex flex-wrap items-center lg:items-end justify-between gap-5 pb-7.5">
                    <div className="flex flex-col justify-center gap-2">
                        <h1 className="text-xl font-medium leading-none text-mono">
                            Software Engineer
                        </h1>
                        <div className="flex items-center gap-2 text-sm font-normal text-secondary-foreground">
                            Central Hub for Personal Customization
                        </div>
                    </div>
                </div>
            </div>

            <div className="kt-container-fixed mb-10">
                <div className="grid grid-cols-3 gap-5 lg:gap-7.5 h-full items-stretch">
                    <div className="kt-card flex-col justify-between gap-6 h-full bg-cover rtl:bg-[left_top_-1.7rem] bg-[right_top_-1.7rem] bg-no-repeat channel-stats-bg">
                        <i className="ki-filled ki-users text-2xl text-primary w-7 mt-4 ms-5"></i>
                        <div className="flex flex-col gap-1 pb-4 px-5">
                            <span className="text-3xl font-semibold text-mono">
                             0
                            </span>
                            <span className="text-sm font-normal text-secondary-foreground">
                             Total Candidates
                            </span>
                        </div>
                    </div>

                    <div className="kt-card flex-col justify-between gap-6 h-full bg-cover rtl:bg-[left_top_-1.7rem] bg-[right_top_-1.7rem] bg-no-repeat channel-stats-bg">
                        <i className="ki-filled ki-users text-2xl text-foreground w-7 mt-4 ms-5"></i>
                        <div className="flex flex-col gap-1 pb-4 px-5">
                            <span className="text-3xl font-semibold text-mono">
                             0
                            </span>
                            <span className="text-sm font-normal text-secondary-foreground">
                             Total Approved
                            </span>
                        </div>
                    </div>

                    <div className="kt-card flex-col justify-between gap-6 h-full bg-cover rtl:bg-[left_top_-1.7rem] bg-[right_top_-1.7rem] bg-no-repeat channel-stats-bg">
                        <i className="ki-filled ki-users text-2xl text-muted-foreground w-7 mt-4 ms-5"></i>
                        <div className="flex flex-col gap-1 pb-4 px-5">
                            <span className="text-3xl font-semibold text-mono">
                             0
                            </span>
                            <span className="text-sm font-normal text-secondary-foreground">
                             Total Rejection
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="kt-container-fixed">
                <div className="kt-card mb-10">
                    <div className="kt-card-header">
                        <h3 className="kt-card-title">Candidates</h3>
                        <div className="kt-input max-w-48">
                            <i className="ki-filled ki-magnifier"></i>
                            <input type="text" placeholder="Search..." className="kt-input sm:w-48" data-kt-datatable-search="#kt_datatable_remote_source"/>
                        </div>
                    </div>
                    <div id="kt_datatable_remote_source" className="kt-card-table" data-kt-datatable-page-size="10" data-kt-datatable-state-save="true">
                        <div className="kt-table-wrapper kt-scrollable">
                            <table className="kt-table" data-kt-datatable-table="true">
                                <thead>
                                <tr>
                                    <th scope="col" className="w-30" data-kt-datatable-column="name">
                                        <span className="kt-table-col"
                                        ><span className="kt-table-col-label">Name</span
                                        ><span className="kt-table-col-sort"></span
                                        ></span>
                                    </th>
                                    <th scope="col" className="w-30" data-kt-datatable-column="gender">
                                        <span className="kt-table-col">
                                            <span className="kt-table-col-label">Gender</span>
                                            <span className="kt-table-col-sort"></span>
                                        </span>
                                    </th>
                                    <th scope="col" className="w-30" data-kt-datatable-column="status">
                                        <span className="kt-table-col">
                                            <span className="kt-table-col-label">Status</span>
                                            <span className="kt-table-col-sort"></span>
                                        </span>
                                    </th>
                                    <th scope="col" className="w-30" data-kt-datatable-column="quality">
                                        <span className="kt-table-col">
                                            <span className="kt-table-col-label">Date</span>
                                            <span className="kt-table-col-sort"></span>
                                        </span>
                                    </th>
                                    <th scope="col" className="w-24" data-kt-datatable-column="action">
                                        <span className="kt-table-col">
                                            <span className="kt-table-col-label">Action</span>
                                            <span className="kt-table-col-sort"></span>
                                        </span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>

                        <div className="kt-datatable-toolbar">
                            <div className="kt-datatable-length">Show<select className="kt-select kt-select-sm w-16" name="perpage" data-kt-datatable-size="true"></select>per page</div>
                            <div className="kt-datatable-info">
                                <span data-kt-datatable-info="true"></span>
                                <div className="kt-datatable-pagination" data-kt-datatable-pagination="true"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="kt-modal" data-kt-modal="true" data-kt-modal-backdrop-static="true" id="create-modal">
                <div className="kt-modal-content max-w-[980px] top-[2%]">
                    <div className="kt-modal-header">
                        <div className="d-flex">
                            <h3 className="kt-modal-title">Create Opportunity</h3>
                            <p className="gap-2 text-sm font-normal text-secondary-foreground">Add opportunity to the system.</p>
                        </div>
                        <button
                            type="button"
                            className="kt-modal-close"
                            aria-label="Close modal"
                            onClick={resetForm.bind(null, "create-modal", "opportunity-form")}
                            data-kt-modal-dismiss="#modal"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                 stroke-linejoin="round" className="lucide lucide-x" aria-hidden="true">
                                <path d="M18 6 6 18"></path>
                                <path d="m6 6 12 12"></path>
                            </svg>
                        </button>
                    </div>

                    <div className="kt-modal-body p-0">
                        <form action="#" method="post">
                            <div data-kt-stepper="true">
                                <div className="kt-card-header h-auto px-10 py-5">
                                    <div data-kt-stepper-item="#stepper_1" className="active flex gap-2.5 items-center">
                                        <div className="shrink-0 rounded-full size-8 flex items-center justify-center text-sm font-semibold bg-muted text-muted-foreground kt-stepper-item-active:bg-primary kt-stepper-item-active:text-primary-foreground kt-stepper-item-completed:bg-green-500 kt-stepper-item-completed:text-white">
                                            <span data-kt-stepper-number="true" className="kt-stepper-item-completed:hidden">1</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                 stroke-linecap="round" stroke-linejoin="round"
                                                 className="lucide lucide-check size-4 hidden kt-stepper-item-completed:inline"
                                                 aria-hidden="true">
                                                <path d="M20 6 9 17l-5-5"></path>
                                            </svg>
                                        </div>
                                        <div className="flex flex-col gap-0.5">
                                            <h4 className="text-sm font-medium text-mono kt-stepper-item-completed:opacity-70">Type</h4>
                                            <span className="text-sm text-muted-foreground kt-stepper-item-completed:opacity-70">Step 1</span>
                                        </div>
                                    </div>
                                    <div data-kt-stepper-item="#stepper_2" className="flex gap-2.5 items-center">
                                        <div className="shrink-0 rounded-full size-8 flex items-center justify-center text-sm font-semibold bg-muted text-muted-foreground kt-stepper-item-active:bg-primary kt-stepper-item-active:text-primary-foreground kt-stepper-item-completed:bg-green-500 kt-stepper-item-completed:text-white">
                                            <span data-kt-stepper-number="true" className="kt-stepper-item-completed:hidden">2</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check size-4 hidden kt-stepper-item-completed:inline" aria-hidden="true">
                                                <path d="M20 6 9 17l-5-5"></path>
                                            </svg>
                                        </div>
                                        <div className="flex flex-col gap-0.5">
                                            <h4 className="text-sm font-medium text-mono kt-stepper-item-completed:opacity-70">Basic Info</h4>
                                            <span className="text-sm text-muted-foreground kt-stepper-item-completed:opacity-70">Step 2</span>
                                        </div>
                                    </div>
                                    <div data-kt-stepper-item="#stepper_3" className="flex gap-2.5 items-center">
                                        <div className="shrink-0 rounded-full size-8 flex items-center justify-center text-sm font-semibold bg-muted text-muted-foreground kt-stepper-item-active:bg-primary kt-stepper-item-active:text-primary-foreground kt-stepper-item-completed:bg-green-500 kt-stepper-item-completed:text-white">
                                            <span data-kt-stepper-number="true" className="kt-stepper-item-completed:hidden">3</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check size-4 hidden kt-stepper-item-completed:inline" aria-hidden="true">
                                                <path d="M20 6 9 17l-5-5"></path>
                                            </svg>
                                        </div>
                                        <div className="flex flex-col gap-0.5">
                                            <h4 className="text-sm font-medium text-mono kt-stepper-item-completed:opacity-70">Requirement</h4>
                                            <span className="text-sm text-muted-foreground kt-stepper-item-completed:opacity-70">Step 3</span>
                                        </div>
                                    </div>
                                    <div data-kt-stepper-item="#stepper_4" className="flex gap-2.5 items-center">
                                        <div className="shrink-0 rounded-full size-8 flex items-center justify-center text-sm font-semibold bg-muted text-muted-foreground kt-stepper-item-active:bg-primary kt-stepper-item-active:text-primary-foreground kt-stepper-item-completed:bg-green-500 kt-stepper-item-completed:text-white">
                                            <span data-kt-stepper-number="true" className="kt-stepper-item-completed:hidden">4</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check size-4 hidden kt-stepper-item-completed:inline" aria-hidden="true">
                                                <path d="M20 6 9 17l-5-5"></path>
                                            </svg>
                                        </div>
                                        <div className="flex flex-col gap-0.5">
                                            <h4 className="text-sm font-medium text-mono kt-stepper-item-completed:opacity-70">Settings</h4>
                                            <span className="text-sm text-muted-foreground kt-stepper-item-completed:opacity-70">Step 4</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="kt-card-content px-5">
                                    <div className="" id="stepper_1">
                                        <div id="stepper_1">
                                            <div className="flex flex-col gap-2 mb-6">
                                                <h3 className="text-base font-medium text-mono">Opportunity Type</h3>
                                                <p className="text-sm text-muted-foreground">Choose the type of opportunity you are creating.</p>
                                            </div>
                                            <div className="grid grid-cols-2 gap-3">
                                                {[
                                                    { value: "job", title: "Job", description: "Full-time or part-time employment opportunities." },
                                                    { value: "apprenticeship", title: "Apprenticeship", description: "Earn while you learn on-the-job training programs." },
                                                    { value: "internship", title: "Internship", description: "Short-term work experience for students or graduates." },
                                                    { value: "training", title: "Training", description: "Skills development and professional training programs." },
                                                    { value: "tickets", title: "Tickets", description: "Event tickets, workshops or conference access." },
                                                    { value: "scholarship", title: "Scholarship", description: "Financial aid for educational pursuits." },
                                                    { value: "funding", title: "Funding", description: "Grants or funding for projects and businesses." },
                                                ].map((type) => (
                                                    <label key={type.value} htmlFor={`type_${type.value}`} className={`relative flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all border-border hover:border-primary hover:bg-primary/5 has-[:checked]:border-primary has-[:checked]:bg-primary/5`}>
                                                        <input
                                                            type="radio"
                                                            id={`type_${type.value}`}
                                                            name="opportunity_type"
                                                            value={type.value}
                                                            className="mt-0.5 kt-radio"
                                                            defaultChecked={type.value === "job"}
                                                            required
                                                        />
                                                        <div className="flex flex-col gap-0.5">
                                                            <span className="text-sm text-base leading-5 font-medium text-mono">{type.title}</span>
                                                            <span className="text-xs text-muted-foreground">{type.description}</span>
                                                        </div>
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="hidden" id="stepper_2">
                                        <div className="flex flex-col gap-2 mb-6">
                                            <h3 className="text-base font-medium text-mono">Basic Information</h3>
                                            <p className="text-sm text-muted-foreground">Fill in the details for this opportunity.</p>
                                        </div>

                                        {/* Application Type */}
                                        <div className="flex flex-col gap-2 mb-5">
                                            <label className="kt-form-label font-normal text-mono">Application Type <span className="text-red-500">*</span></label>
                                            <p className="text-sm text-muted-foreground">How would you like applicants to apply?</p>
                                            <div className="grid grid-cols-2 gap-3">
                                                <label
                                                    htmlFor="app_type_direct"
                                                    className="relative flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all border-border hover:border-primary hover:bg-primary/5 has-[:checked]:border-primary has-[:checked]:bg-primary/5"
                                                >
                                                    <input
                                                        type="radio"
                                                        id="app_type_direct"
                                                        name="application_type"
                                                        value="direct"
                                                        className="mt-0.5 kt-radio"
                                                        defaultChecked
                                                        onChange={() => setApplicationType("direct")}
                                                        required
                                                    />
                                                    <div className="flex flex-col gap-0.5">
                                                        <span className="text-sm font-medium text-mono">Directly through the Imisepela App</span>
                                                        <span className="text-xs text-muted-foreground">You have full access to applications through this dashboard.</span>
                                                    </div>
                                                </label>
                                                <label
                                                    htmlFor="app_type_external"
                                                    className="relative flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all border-border hover:border-primary hover:bg-primary/5 has-[:checked]:border-primary has-[:checked]:bg-primary/5"
                                                >
                                                    <input
                                                        type="radio"
                                                        id="app_type_external"
                                                        name="application_type"
                                                        value="external"
                                                        className="mt-0.5 kt-radio"
                                                        onChange={() => setApplicationType("external")}
                                                        required
                                                    />
                                                    <div className="flex flex-col gap-0.5">
                                                        <span className="text-sm font-medium text-mono">External Link (Not Recommended)</span>
                                                        <span className="text-xs text-muted-foreground">Applicants are redirected to an external website to apply.</span>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="flex flex-col gap-5">

                                            {/*/!* Position *!/*/}
                                            {/*<div className="flex flex-col gap-1">*/}
                                            {/*    <label className="kt-form-label font-normal text-mono">Position <span className="text-red-500">*</span></label>*/}
                                            {/*    <input id="position" type="text" className="kt-input" placeholder="Enter job title here (eg. Waiter, Receptionist, Apprentice Plumber)" autoComplete="off" required />*/}
                                            {/*</div>*/}

                                            {/* Position */}
                                            <div className="flex flex-col gap-1">
                                                <label className="kt-form-label font-normal text-mono">Name of opportunity <span className="text-red-500">*</span></label>
                                                <input id="position" type="text" className="kt-input" placeholder="Name this opportunity (eg. Empowerment grant, Small Business Loan, etc)" autoComplete="off" required />
                                            </div>

                                            {/* Link to Application */}
                                            <div className="flex flex-col gap-1">
                                                <label className={`kt-form-label font-normal text-mono ${applicationType === "direct" ? "opacity-40" : ""}`}>
                                                    Link to Application {applicationType === "external" && <span className="text-red-500">*</span>}
                                                </label>
                                                <input
                                                    id="link"
                                                    type="url"
                                                    className={`kt-input ${applicationType === "direct" ? "opacity-40 cursor-not-allowed" : ""}`}
                                                    placeholder="https://..."
                                                    autoComplete="off"
                                                    required={applicationType === "external"}
                                                    disabled={applicationType === "direct"}
                                                />
                                                {applicationType === "direct" && (
                                                    <p className="text-xs text-muted-foreground">Not required — applicants will apply directly through the app.</p>
                                                )}
                                            </div>

                                            {/* Location */}
                                            <div className="flex flex-col gap-1">
                                                <label className="kt-form-label font-normal text-mono">Location</label>
                                                <input id="location" type="text" className="kt-input" placeholder="Enter location" autoComplete="off" />
                                            </div>

                                            {/* Description, Qualification, Experience Cards */}
                                            <div className="grid grid-cols-3 gap-3">
                                                {[
                                                    { id: "description", title: "Describe this opportunity", icon: "ki-filled ki-document", required: true },
                                                    { id: "qualifications", title: "What qualifications are required?", icon: "ki-filled ki-book", required: false },
                                                    { id: "experience", title: "What experience is required?", icon: "ki-filled ki-briefcase", required: false },
                                                ].map((item) => (
                                                    <div
                                                        key={item.id}
                                                        onClick={() => handleOpenEditor(item.id, item.title)}
                                                        className="flex flex-col gap-2 p-4 rounded-lg border border-border hover:border-primary hover:bg-primary/5 cursor-pointer transition-all"
                                                    >
                                                        <div className="flex items-center justify-between">
                                                            <div className="flex items-center gap-2">
                                                                <i className={`${item.icon} text-lg text-muted-foreground`}></i>
                                                                <span className="text-sm font-medium text-mono">{item.title}
                                                                    {item.required && <span className="text-red-500 ml-1">*</span>}</span>
                                                            </div>
                                                            <i className="ki-filled ki-pencil text-sm text-muted-foreground"></i>
                                                        </div>
                                                        <p className="text-xs text-muted-foreground line-clamp-2">
                                                            {editorValues[item.id] ? editorValues[item.id].replace(/<[^>]+>/g, '') : `Click to add ${item.title.toLowerCase()}...`}
                                                        </p>
                                                        {editorValues[item.id] && (
                                                            <span className="text-xs text-primary font-medium">● Filled</span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Text Editor Modal */}
                                            {editorModal.open && (
                                                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
                                                    <div className="bg-background rounded-xl border border-border w-full max-w-[900px] mx-4 flex flex-col gap-0 shadow-lg">
                                                        <div className="flex items-center justify-between px-5 py-4 border-b border-border">
                                                            <h3 className="text-sm font-medium text-mono">{editorModal.title}</h3>
                                                            <button
                                                                type="button"
                                                                onClick={handleCloseEditor}
                                                                className="text-muted-foreground hover:text-mono transition-colors"
                                                            >
                                                                <i className="ki-filled ki-cross text-lg"></i>
                                                            </button>
                                                        </div>
                                                        <div className="p-5">
                                                        <textarea
                                                            className="kt-input w-full kt-textarea"
                                                            style={{ minHeight: "500px" }}
                                                            placeholder={`Enter ${editorModal.title.toLowerCase()}...`}
                                                            value={editorValues[editorModal.id] || ""}
                                                            onChange={(e) => setEditorValues(prev => ({ ...prev, [editorModal.id]: e.target.value }))}
                                                        ></textarea>
                                                        </div>
                                                        <div className="flex justify-end gap-2 px-5 py-4 border-t border-border">
                                                            <button type="button" onClick={handleCloseEditor} className="kt-btn kt-btn-secondary">Cancel</button>
                                                            <button type="button" onClick={handleCloseEditor} className="kt-btn kt-btn-primary">Save</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="hidden" id="stepper_3">
                                        <div className="flex flex-col gap-2 mb-6">
                                            <h3 className="text-base font-medium text-mono">Requirements</h3>
                                            <p className="text-sm text-muted-foreground">Define what information and documents are required from applicants.</p>
                                        </div>

                                        <div className="flex flex-col gap-5">

                                            {/* Information Required */}
                                            <div className="flex flex-col gap-3">
                                                <div className="flex flex-col gap-1">
                                                    <label className="kt-form-label font-normal text-mono">What information do you need from the applicants?</label>
                                                    <p className="text-sm text-muted-foreground">Select the information applicants must provide.</p>
                                                </div>
                                                <div className="grid grid-cols-2 gap-3">
                                                    {[
                                                        { id: "req_name", label: "Full Name", description: "Applicant's full legal name." },
                                                        { id: "req_province", label: "Province", description: "Province where the applicant resides." },
                                                        { id: "req_cv", label: "CV / Resume", description: "Uploaded curriculum vitae or resume." },
                                                        { id: "req_contact", label: "Contact Number", description: "Applicant's phone or mobile number." },
                                                        { id: "req_email", label: "Email Address", description: "Applicant's active email address." },
                                                        { id: "req_id", label: "ID Number", description: "National identification number." },
                                                        { id: "req_dob", label: "Date of Birth", description: "Applicant's date of birth." },
                                                        { id: "req_gender", label: "Gender", description: "Applicant's gender identity." },
                                                    ].map((item) => (
                                                        <label
                                                            key={item.id}
                                                            htmlFor={item.id}
                                                            className="relative flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all border-border hover:border-primary hover:bg-primary/5 has-[:checked]:border-primary has-[:checked]:bg-primary/5"
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                id={item.id}
                                                                className="mt-0.5 kt-checkbox"
                                                            />
                                                            <div className="flex flex-col gap-0.5">
                                                                <span className="text-sm font-medium text-mono">{item.label}</span>
                                                                <span className="text-xs text-muted-foreground">{item.description}</span>
                                                            </div>
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Additional Documents */}
                                            <div className="flex flex-col gap-3 pt-4 border-t border-border">
                                                <div className="flex flex-col gap-1">
                                                    <label className="kt-form-label font-normal text-mono">Are any additional documents needed?</label>
                                                    <p className="text-sm text-muted-foreground">Do you need applicants to upload additional documents?</p>
                                                </div>
                                                <div className="grid grid-cols-2 gap-3">
                                                    <label
                                                        htmlFor="docs_no"
                                                        className="relative flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all border-border hover:border-primary hover:bg-primary/5 has-[:checked]:border-primary has-[:checked]:bg-primary/5"
                                                    >
                                                        <input
                                                            type="radio"
                                                            id="docs_no"
                                                            name="additional_docs"
                                                            value="no"
                                                            className="mt-0.5 kt-radio"
                                                            defaultChecked
                                                            onChange={() => setRequiresDocs(false)}
                                                        />
                                                        <div className="flex flex-col gap-0.5">
                                                            <span className="text-sm font-medium text-mono">No</span>
                                                            <span className="text-xs text-muted-foreground">No additional documents needed.</span>
                                                        </div>
                                                    </label>
                                                    <label
                                                        htmlFor="docs_yes"
                                                        className="relative flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all border-border hover:border-primary hover:bg-primary/5 has-[:checked]:border-primary has-[:checked]:bg-primary/5"
                                                    >
                                                        <input
                                                            type="radio"
                                                            id="docs_yes"
                                                            name="additional_docs"
                                                            value="yes"
                                                            className="mt-0.5 kt-radio"
                                                            onChange={() => setRequiresDocs(true)}
                                                        />
                                                        <div className="flex flex-col gap-0.5">
                                                            <span className="text-sm font-medium text-mono">Yes</span>
                                                            <span className="text-xs text-muted-foreground">Applicants must upload specific documents.</span>
                                                        </div>
                                                    </label>
                                                </div>

                                                {/* Document Names - shown only if Yes */}
                                                {requiresDocs && (
                                                    <div className="flex flex-col gap-3 mt-1">
                                                        <div className="flex flex-col gap-1">
                                                            <label className="kt-form-label font-normal text-mono">Document Name(s) Required</label>
                                                            <p className="text-sm text-muted-foreground">List the documents applicants must upload.</p>
                                                        </div>
                                                        <div className="grid grid-cols-2 gap-3">
                                                            {[
                                                                { id: "doc_matric", label: "Matric Certificate", description: "Grade 12 certificate or equivalent." },
                                                                { id: "doc_id_copy", label: "ID Copy", description: "Certified copy of national ID." },
                                                                { id: "doc_portfolio", label: "Portfolio", description: "Work samples or portfolio documents." },
                                                                { id: "doc_transcript", label: "Academic Transcript", description: "Official academic records." },
                                                                { id: "doc_reference", label: "Reference Letter", description: "Professional or academic reference." },
                                                                { id: "doc_certificate", label: "Certificates", description: "Any relevant certificates." },
                                                            ].map((item) => (
                                                                <label
                                                                    key={item.id}
                                                                    htmlFor={item.id}
                                                                    className="relative flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all border-border hover:border-primary hover:bg-primary/5 has-[:checked]:border-primary has-[:checked]:bg-primary/5"
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        id={item.id}
                                                                        className="mt-0.5 kt-checkbox"
                                                                    />
                                                                    <div className="flex flex-col gap-0.5">
                                                                        <span className="text-sm font-medium text-mono">{item.label}</span>
                                                                        <span className="text-xs text-muted-foreground">{item.description}</span>
                                                                    </div>
                                                                </label>
                                                            ))}
                                                        </div>
                                                        <div className="flex flex-col gap-1 mt-1">
                                                            <label className="kt-form-label font-normal text-mono">Other Documents</label>
                                                            <input
                                                                id="doc_other"
                                                                type="text"
                                                                className="kt-input"
                                                                placeholder="e.g. Driver's licence, Teaching qualification etc..."
                                                                autoComplete="off"
                                                            />
                                                            <p className="text-xs text-muted-foreground">Separate multiple documents with a comma.</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    </div>

                                    {/* Step 4 */}
                                    <div className="hidden" id="stepper_4">
                                        <div className="flex flex-col gap-2 mb-6">
                                            <h3 className="text-base font-medium text-mono">When can applicants apply?</h3>
                                            <p className="text-sm text-muted-foreground">Select the dates for your application process.</p>
                                        </div>

                                        <div className="flex flex-col gap-5">

                                            {/* Dates Section */}
                                            <div className="flex flex-col gap-3">
                                                <div className="grid grid-cols-3 gap-3">
                                                    <div className="flex flex-col gap-1">
                                                        <label className="kt-form-label font-normal text-mono">Appearance Date <span className="text-red-500">*</span></label>
                                                        <p className="text-xs text-muted-foreground">When should this opportunity appear on the app?</p>
                                                        <div className="kt-input">
                                                            <i className="ki-outline ki-calendar"></i>
                                                            <input
                                                                id="date_appear"
                                                                className="grow"
                                                                type="text"
                                                                placeholder="Select date"
                                                                data-kt-date-picker="true"
                                                                data-kt-date-picker-input-mode="true"
                                                                data-kt-date-picker-position-to-input="left"
                                                                readOnly
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-col gap-1">
                                                        <label className="kt-form-label font-normal text-mono">Closing Date <span className="text-red-500">*</span></label>
                                                        <p className="text-xs text-muted-foreground">When does this opportunity close?</p>
                                                        <div className="kt-input">
                                                            <i className="ki-outline ki-calendar"></i>
                                                            <input
                                                                id="date_closing"
                                                                className="grow"
                                                                type="text"
                                                                placeholder="Select date"
                                                                data-kt-date-picker="true"
                                                                data-kt-date-picker-input-mode="true"
                                                                data-kt-date-picker-position-to-input="left"
                                                                readOnly
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-col gap-1">
                                                        <label className="kt-form-label font-normal text-mono">Results Date</label>
                                                        <p className="text-xs text-muted-foreground">When will applicants be notified of results?</p>
                                                        <div className="kt-input">
                                                            <i className="ki-outline ki-calendar"></i>
                                                            <input
                                                                id="date_results"
                                                                className="grow"
                                                                type="text"
                                                                placeholder="Select date"
                                                                data-kt-date-picker="true"
                                                                data-kt-date-picker-input-mode="true"
                                                                data-kt-date-picker-position-to-input="left"
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* AI Shortlisting */}
                                            <div className="flex flex-col gap-3 pt-4 border-t border-border">
                                                <div className="flex flex-col gap-1">
                                                    <label className="kt-form-label font-normal text-mono">Imisepela AI Shortlisting</label>
                                                    <p className="text-sm text-muted-foreground">
                                                        Imisepela AI reviews the relevant data from all of your applications to shortlist the top candidates for you. Would you like to use this option?
                                                    </p>
                                                </div>
                                                <div className="grid grid-cols-2 gap-3">
                                                    <label
                                                        htmlFor="ai_yes"
                                                        className="relative flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all border-border hover:border-primary hover:bg-primary/5 has-[:checked]:border-primary has-[:checked]:bg-primary/5"
                                                    >
                                                        <input
                                                            type="radio"
                                                            id="ai_yes"
                                                            name="ai_shortlist"
                                                            value="yes"
                                                            className="mt-0.5 kt-radio"
                                                            onChange={() => setUseAI(true)}
                                                        />
                                                        <div className="flex flex-col gap-0.5">
                                                            <span className="text-sm font-medium text-mono">Yes, use AI Shortlisting</span>
                                                            <span className="text-xs text-muted-foreground">Let Imisepela AI automatically shortlist the best candidates.</span>
                                                        </div>
                                                    </label>
                                                    <label
                                                        htmlFor="ai_no"
                                                        className="relative flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all border-border hover:border-primary hover:bg-primary/5 has-[:checked]:border-primary has-[:checked]:bg-primary/5"
                                                    >
                                                        <input
                                                            type="radio"
                                                            id="ai_no"
                                                            name="ai_shortlist"
                                                            value="no"
                                                            className="mt-0.5 kt-radio"
                                                            defaultChecked
                                                            onChange={() => setUseAI(false)}
                                                        />
                                                        <div className="flex flex-col gap-0.5">
                                                            <span className="text-sm font-medium text-mono">No, I'll review manually</span>
                                                            <span className="text-xs text-muted-foreground">You will manually review all applications yourself.</span>
                                                        </div>
                                                    </label>
                                                </div>

                                                {/* AI info box - shown only if Yes */}
                                                {useAI && (
                                                    <div className="flex items-start gap-3 p-4 rounded-lg bg-primary/5 border border-blue-400">
                                                        <i className="ki-filled ki-information-2 text-primary text-lg mt-0.5"></i>
                                                        <div className="flex flex-col gap-1">
                                                            <span className="text-sm font-medium text-mono">How AI Shortlisting works</span>
                                                            <p className="text-xs">
                                                                Once your opportunity closes, Imisepela AI will analyse all applications based on the qualifications,
                                                                experience and requirements you have set. It will then rank and shortlist the top candidates,
                                                                saving you time and ensuring a fair review process.
                                                            </p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Privacy Policy */}
                                            <div className="flex flex-col gap-3 pt-4 border-t border-border">
                                                <label
                                                    htmlFor="privacy_policy"
                                                    className="relative flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all border-border hover:border-primary hover:bg-primary/5 has-[:checked]:border-primary has-[:checked]:bg-primary/5"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="privacy_policy"
                                                        className="mt-0.5 kt-checkbox"
                                                        required
                                                    />
                                                    <div className="flex flex-col gap-0.5">
                                                        <span className="text-sm font-medium text-mono">Data Privacy Policy <span className="text-red-500">*</span></span>
                                                        <span className="text-xs text-muted-foreground">
                        I agree to the <a href="#" className="text-primary hover:underline">data privacy policy</a> and confirm that all information provided is accurate.
                    </span>
                                                    </div>
                                                </label>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="kt-card-footer justify-between p-5">
                                    <div>
                                        <button className="kt-btn kt-btn-secondary kt-stepper-first:hidden" data-kt-stepper-back="true">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-left" aria-hidden="true">
                                                <path d="m12 19-7-7 7-7"></path>
                                                <path d="M19 12H5"></path>
                                            </svg>
                                            Back
                                        </button>
                                    </div>
                                    <div>
                                        <button className="kt-btn kt-btn-secondary kt-stepper-last:hidden" data-kt-stepper-next="true">
                                            Next
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right" aria-hidden="true">
                                                <path d="M5 12h14"></path>
                                                <path d="m12 5 7 7-7 7"></path>
                                            </svg>
                                        </button>
                                        <button className="kt-btn hidden kt-stepper-last:inline-flex">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Applicant;
